import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import { Box , Link } from '@mui/material';

import { RouterLink } from 'src/routes/components';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, src }) => {
  // OR using local (public folder)
  // -------------------------------------------------------
  const logo = (
    <Box
      component="img"
      src={src ?? '/logo/logo_single.svg'}
      sx={{ width: 40, height: 40, cursor: 'pointer', objectFit: 'contain', ...sx }}
    />
  );

  if (disabledLink) {
    return logo;
  }

  return (
    <Link component={RouterLink} href="/" sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
  src: PropTypes.string
};

export default Logo;
